<template>
    <img
        :src="`/static/img/${path}`"
        :height="`${height}px`"
        :width="`${width}px`"
    />
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('StaticImage', {
        props: {
            path: {
                type: String,
                default: '',
            },
            height: {
                type: Number,
                default: 14,
            },
            width: {
                type: Number,
                default: 18,
            },
        }
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/StaticImage.vue